var map = {
	"./abandoned.svg": 8773,
	"./art.svg": 3612,
	"./drone.svg": 6726,
	"./film.svg": 3968,
	"./industrial.svg": 1953,
	"./nature.svg": 8951,
	"./roads.svg": 9043,
	"./sand.svg": 580,
	"./sports.svg": 103,
	"./urban.svg": 3614,
	"./water.svg": 6725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7330;